import { FormErrorsSchema } from "../../types";

export const Select = ({
  label = undefined,
  name,
  key = undefined,
  options,
  errors = undefined,
  value,
  setValue = undefined,
  required = false,
  disabled = false,
  autoComplete = "off",
  autoFocus = false,
  onChange = null,
  containerClassName = "w-full mt-6",
}: {
  label?: string;
  name: string;
  key?: string;
  options: Array<{ value: string; label: string }>;
  errors?: FormErrorsSchema;
  value: string;
  setValue?: Function | React.Dispatch<React.SetStateAction<string>>;
  disabled?: boolean;
  required?: boolean;
  autoComplete?: string;
  autoFocus?: boolean;
  onChange?: Function | null;
  containerClassName?: string;
}) => {
  return (
    <div className={containerClassName} key={key}>
      {label && (
        <label htmlFor={name} className="block mb-2 font-medium text-gray-900">
          {label}
          {required && <span className="ml-1 text-red-500">*</span>}
        </label>
      )}
      <select
        name={name}
        id={name}
        className="bg-gray-50 border-gray-300 text-gray-900 focus:border-brand-blue-400 focus:ring-0 focus:ring-gray-300 text-sm block w-full disabled:cursor-not-allowed disabled:bg-gray-200"
        required={required}
        autoComplete={autoComplete}
        value={value}
        onChange={async (e: React.ChangeEvent<HTMLSelectElement>) => {
          const { name, value } = e.target;
          if (setValue) {
            setValue(value);
          }

          if (onChange) {
            await onChange(value, name);
          }
        }}
        disabled={disabled}
        autoFocus={autoFocus}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {errors?.[name]?.map((error) => (
        <p key={`${name}-${error}`} className="mt-2 text-sm text-red-600">
          {error}
        </p>
      ))}
    </div>
  );
};
